(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* =============================================
     SCROLL ANIMATION (IntersectionObserver)
     ============================================= */
  (function() {
    var cards = document.querySelectorAll('[data-scroll-animation]');
    if (!cards.length) return;

    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function(card) { card.classList.add('is-visible'); });
      return;
    }

    var staggerDelay = 0;
    var lastBatch = null;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var card = entry.target;
          var animation = card.getAttribute('data-scroll-animation');

          if (animation === 'stagger') {
            // Stagger: add incremental delay per card entering viewport together
            var batchKey = Math.floor(Date.now() / 200);
            if (batchKey !== lastBatch) {
              staggerDelay = 0;
              lastBatch = batchKey;
            }
            card.style.transitionDelay = staggerDelay + 'ms';
            staggerDelay += 100;
          }

          card.classList.add('is-visible');
          observer.unobserve(card);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    cards.forEach(function(card) {
      observer.observe(card);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
